import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {dateFilters, dateFilterToPeriod} from 'shared';
import {DxToolbarComponent} from 'devextreme-angular';
import {Subject, Subscription} from 'rxjs';
import {TransportInterventionsPageRequest} from '../transport-interventions-page/transport-interventions-page-request';

@Component({
  selector: 'app-transport-interventions-toolbar',
  templateUrl: './transport-interventions-toolbar.component.html',
  styleUrls: ['./transport-interventions-toolbar.component.scss']
})
export class TransportInterventionsToolbarComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Input()
  request: TransportInterventionsPageRequest;

  // loadingVisible = false;
  generateButtonOptions: any;
  dateFilters = dateFilters;
  // private isLoadingSub: Subscription;

  constructor() {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  ngOnInit() {

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: (e: any) => {
        const result = e.validationGroup.validate();
        if (result.isValid) {
          this.request.submit();
        }
      }
    };
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    if (this.request.currentFilter === 0 || e.value === 0) {
      setTimeout(() => {
        this.toolbar.instance.repaint();
      }, 100);
    }
    this.request.currentFilter = e.value;
    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }

  ngAfterViewInit(): void {
    // this.isLoadingSub = this.request.loading$.subscribe(loading => this.loadingVisible = loading);
  }

  ngOnDestroy(): void {
    // this.isLoadingSub.unsubscribe();
  }
}
